<!-- <p>employee-attendance-response-dialog works!</p> -->
<div class="face-match-success-container">
  <div
    class="background"
    [ngStyle]="
      employee?.isMultiple && false
        ? { 'background-color': 'rgba(255, 0, 0, 0.5)' }
        : {}
    "
  >
    <div class="content">
      <div class="text" [@textAnimation]="textAnimationState">
        {{
          employee?.isMultiple
            ? "Employee Re-CheckIn"
            : employee?.isCheckIn
            ? "Employee Checked-In"
            : employee?.isCheckOut
            ? "Employee Checked-Out"
            : "Attendance Registered"
        }}
      </div>
      <div class="image-container">
        <div
          class="circle"
          [ngStyle]="
            employee?.isCheckOut ? { border: '5px solid #ff0000' } : {}
          "
          [@rotateAnimation]="rotateState"
        >
          <img [src]="employee?.employeeProfile" alt="Profile Image" />
        </div>
        <div class="name">
          <div style="width: 100%; display: flex">
            Employee Name: &nbsp;<b>{{ employee?.employeeName }}</b>
          </div>
          <div style="width: 100%; display: flex">
            Employee Phone: &nbsp;<b>{{ employee?.employeeNumber }}</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
